type WindowWithAnalytics = Window & {
  clarity: {
    (...args: any[]): void;
    q: unknown[];
  };
  gtag: (...args: unknown[]) => void;
  dataLayer: unknown[];
};

const windowWithAnalytics = window as unknown as WindowWithAnalytics;

export const loadClarity = (clarityId: string) => {
  windowWithAnalytics.clarity =
    windowWithAnalytics.clarity ||
    function () {
      (windowWithAnalytics.clarity.q =
        windowWithAnalytics.clarity.q || []).push(arguments);
    };

  if (clarityId) {
    const script = document.createElement("script");
    script.src = `https://www.clarity.ms/tag/${clarityId}`;
    script.async = true;
    document.head.appendChild(script);
  }
};

export const loadGTM = (gtmId: string) => {
  windowWithAnalytics.dataLayer = windowWithAnalytics.dataLayer || [];
  windowWithAnalytics.gtag = function () {
    windowWithAnalytics.dataLayer.push(arguments);
  };

  if (gtmId) {
    const script1 = document.createElement("script");
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
    script1.async = true;
    document.body.appendChild(script1);

    script1.onload = () => {
      windowWithAnalytics.gtag("set", "cookie_flags", "SameSite=None;Secure");
      windowWithAnalytics.gtag("js", new Date());
      windowWithAnalytics.gtag("config", gtmId);
    };
  }
};
